import Vue from "vue";
import Router from "vue-router";
import Homepage from "./views/Homepage.vue";
import Project from "./views/Project.vue";
import Contact from "./views/Contact.vue";
import Default from "./views/Default.vue";
import Flats from "./views/Flats.vue";
import Locals from "./views/Locals.vue";
import About from "./views/About.vue";
import Gallery from "./views/Gallery.vue";
//import History from "./views/History.vue";
import Location from "./views/Location.vue";
import Privacy from "./views/Privacy.vue";
import Finances from "./views/Finances.vue";


Vue.use(Router);



const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "homepage",
      component: Homepage
    },
    {
      path: "/inwestycja",
      name: "project",
      component: Project
    },
    /*
    {
      path: "/historia",
      name: "history",
      component: History
    },
    */
    {
      path: "/lokalizacja",
      name: "location",
      component: Location
    },
    {
      path: "/o-nas",
      name: "about",
      component: About
    },
    {
      path: "/lokale",
      name: "locals",
      component: Locals
    },
    {
      path: "/mieszkania",
      name: "flats",
      component: Flats
    },
    {
      path: "/mieszkania/pietro/:chosenLevel",
      name: "flatsOfLevel",
      component: Flats
    },
    {
      path: "/galeria",
      name: "gallery",
      component: Gallery
    },
    {
      path: "/kontakt",
      name: "kontakt",
      component: Contact
    },
    {
      path: "/prywatnosc",
      name: "privacy",
      component: Privacy
    },
    {
      path: "/finansowanie",
      name: "finances",
      component: Finances
    },

    {
      path :'*',
      component: Default
    },

  ],
  scrollBehavior() {
    return {x: 0, y: 0}
  }
});


router.afterEach(() => {
  const hamburger = document.querySelector('.hamburger');
        const mainNav = document.querySelector('#main-nav');
        if (hamburger) {
            hamburger.classList.remove("change");
        }
        if (mainNav) {
            mainNav.classList.remove("open");
        }
 
});

export default router;